import React, { useCallback, useEffect, useState } from 'react';

import { Avatar, Chip, Dialog, DialogContent } from '@material-ui/core';
import { IconButton, Switch, TextField } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';

import API from 'utils/api';
import { useSources, useSocket } from 'hooks';
import { DialogTitle } from 'components';

import styles from './TwitterDialog.module.scss';

const twitterCard = (twitterAccount, onDeleteAccount) => {
  const labelComp = (
    <div>
      <div className={styles.twitterName}>{twitterAccount.name}</div>
      <div>@{twitterAccount.username}</div>
    </div>
  );

  return (
    <Chip
      label={labelComp}
      avatar={<Avatar src={twitterAccount.profile_image_url} />}
      onDelete={() => onDeleteAccount(twitterAccount)}
      className={styles.chipTag}
      key={twitterAccount.id}
    />
  );
};

const TwitterDialog = props => {
  const { open, onChangeActiveService, onClose, leagueId, teamId } = props;

  const [newTwitterAccount, setNewTwitterAccount] = useState('');
  const [twitterAccounts, setTwitterAccounts] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [update, setUpdate] = useState(0);

  const sources = useSources();

  useSocket('sportsapi', null, {
    refreshTwitterAccounts: () => setUpdate(x => x + 1),
  });

  useEffect(() => {
    if (open) {
      getTwitterAccounts();
    }
  }, [open, getTwitterAccounts, update]);

  const getTwitterAccounts = useCallback(async () => {
    if (leagueId || teamId) {
      const { data } = await API.getTwitterAccounts({ leagueId, teamId });
      if (data) {
        setTwitterAccounts(data);
      }
    }
  }, [leagueId, teamId]);

  const updateTwitterAccounts = ({ teamId, leagueId, twitterAccount, remove }) => {
    API.updateTwitterAccounts({ teamId, leagueId, twitterAccount, remove }, sources).then(
      data => {
        if (!data || data.status !== 201) {
          setErrorMessage(data.error);
        }
      }
    );
  };

  const deleteTwitterAccount = useCallback(
    twitterAccount => {
      if (twitterAccount && twitterAccount.username) {
        const toRemove = true;
        API.updateTwitterAccounts(
          { teamId, leagueId, twitterAccount: twitterAccount.username, remove: toRemove },
          sources
        );
      }
    },
    [teamId, leagueId]
  );

  const dialogContent = (
    <React.Fragment>
      {!!onChangeActiveService && (
        <div>
          Service active
          <Switch
            color="primary"
            checked={props.serviceDisabled}
            onChange={onChangeActiveService}
          />
        </div>
      )}
      <div className={styles.containerInputTag}>
        <TextField
          placeholder="Type a new twitter account"
          className={styles.inputTag}
          value={newTwitterAccount}
          onChange={event => {
            setNewTwitterAccount(event.target.value);
            setErrorMessage('');
          }}
          {...(errorMessage !== '' ? { error: true, helperText: `${errorMessage}` } : {})}
        />

        <IconButton
          type="submit"
          onClick={() => {
            if (newTwitterAccount) {
              updateTwitterAccounts({
                teamId,
                leagueId,
                twitterAccount: newTwitterAccount,
              });

              setNewTwitterAccount('');
            } else {
              setErrorMessage('twitter account is required');
            }
          }}
        >
          <CheckIcon />
        </IconButton>
      </div>
      <div className={styles.containerTags}>
        {twitterAccounts.map(twtAcc => {
          if (twtAcc) {
            return twitterCard(twtAcc, deleteTwitterAccount);
          }
          return null;
        })}
      </div>
    </React.Fragment>
  );

  const onDialogClose = () => {
    onClose();
    setNewTwitterAccount('');
  };

  return (
    <Dialog className={styles.twitterDialog} open={open} onClose={onDialogClose}>
      <DialogTitle onClose={onDialogClose}>Add twitter accounts</DialogTitle>
      <DialogContent>{dialogContent}</DialogContent>
    </Dialog>
  );
};

export default TwitterDialog;
